import { render, staticRenderFns } from "./TopCustomersPerMonthChart.vue?vue&type=template&id=1aecd11e"
import script from "./TopCustomersPerMonthChart.vue?vue&type=script&lang=js"
export * from "./TopCustomersPerMonthChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports